import React, { useEffect, useState } from 'react'
import { MenuList } from '../helpers/MenuList'
import MenuItem from '../components/MenuItem';
import '../styles/Menu.css'
import {  useNavigate } from 'react-router-dom';
import emailjs from '@emailjs/browser';
import { useRef } from 'react';
// import contactImg from '../assets/new-message.jpg'
// import BannerImage from '../assets/leaves mini.jpeg';
import { useStateContext } from '../contexts/contextProvider';
// import phone_sign from "../assets/phone_bluey.jpg";

function Services() {

  const form = useRef()

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_j0cdbvp', 'template_4t8w25s', form.current, 'cBJ0i_aVHr6_F-aIt')
      .then((result) => {
        console.log(result.text);
        alert('Success!')
      }, (error) => {
        console.log(error.text);
        alert('Failed. Check your internet connection and try again')
      });
    e.target.reset();
  };
  
    
  const { currentUser, setcurrentUser } = useStateContext();


  const [admin, setAdmin] = useState(false);
  useEffect(() => {
    if (currentUser) {
      setAdmin(true) 
    }
  }, [currentUser]);
  console.log(admin);

  const nav = useNavigate();
  const logOut = () => {
    setcurrentUser(null);
    localStorage.clear();
    nav('/');
  };



  return (
    <div className='menu'>
      
      <div className='adminLinks' id={admin? "show": "hide"}>
        <h3>Hi {currentUser}!</h3>
        <button className='logOutBtn' onClick={logOut}>Log out</button>
      </div>
      {/* <div className='links'>
        <Link className='lnk' to={'/'}>
          HOME
        </Link>
        <Link className='lnk' to={'/contact'}>
          CONTACT US
        </Link>
        <h1 className='menuTitle'>What we do</h1>
      </div> */}

      <div className='mid'>
        <div className='serviceText'>
          <h1>What we do</h1>
          {/* <p> •	We strive to strengthen community resilience to climate change through climate adaptation measures, early warning systems, disaster risk reduction, ecosystem restoration, and sustainable environmental practices.
              <p>•	We work to advance the integration, documentation, and application of Indigenous knowledge and scientific research to address climate, environmental, health, and development challenges.</p>
              <p>•	We promote environmental health and sustainable livelihoods through awareness, clean energy solutions, climate-sensitive practices, and responsible natural resource management.</p>
              <p>•	We enhance organizational effectiveness and sustainability through good governance, strategic partnerships, capacity development, and resource mobilization.</p>

            </p> */}
          {/* <p>
            We believe and invest in various projects that are helpful economically and environmentally.
          </p> */}
        </div>

      <div className='menuList'>
          {MenuList.map((menuItem, key) => {
            return (
              <MenuItem
                key={key}
                image={menuItem.image}
                // name={menuItem.name}
                description={menuItem.description}
              />
            );
          })}

        </div>

        <div className='contactUs'>
          <form ref={form} onSubmit={sendEmail}
            className='contactForm'>
            <h2>Leave us a message</h2>
            <input
              name='from_name'
              placeholder='Enter your name here' required />
            <input
              name='from_email'
              placeholder='Enter your email address here' required />

            <textarea
              name='message'
              placeholder='Enter your message'
              required></textarea>
            <button type='submit' className='btn btn-lg'>Send message</button>
          </form>
        </div>
      </div>
    </div>
  )
}

export default Services;